import React from "react";
import ErrorMessageFramer from "../framerMotion/ErrorMessageFramer";
import useTranslation from "../CustomHooks/useTranslation";
import { errorMessageContents } from "./ErrorMessageContent";

interface ErrorMessageProps {
  errorMessage: string;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ errorMessage, className }) => {
  const { translate } = useTranslation(errorMessageContents);

  return (
    <ErrorMessageFramer>
      <p className={`text-body2 pt-1 text-negative break-words whitespace-normal ${className}`}>
        {translate(errorMessage)}
      </p>
    </ErrorMessageFramer>
  );
};

export default ErrorMessage;
